import styled from "styled-components";

export const AreaFilter = styled.div`
	padding: 0 1rem 0;
	background: ${({ theme }) => theme.white};
`;

export const HeaderFilter = styled.div`
	position: sticky;
	top: 0;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
	padding: 3rem 0 1rem;
	background: #fff;
	z-index: 1;
`;
export const ContentFilter = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 1rem;
	padding: 0 0 0 0.4rem;

	h5 {
		margin: 0;
	}
	& .MuiPaper-root {
		margin: 1rem 0;
	}

	& .MuiAccordionSummary-root {
		padding: 0;
		background: none;
	}
	& .MuiIconButton-edgeEnd {
		margin: 0;
	}
	& .MuiAccordionSummary-root span {
		color: rgba(0, 0, 0, 0.54);
	}
	& .MuiAccordion-root:before {
		display: none;
	}
	& .MuiPaper-elevation1 {
		box-shadow: none;
	}
	& .MuiAccordionSummary-content {
		margin: 0;
	}

	> button {
		max-width: 100%;
	}
`;
export const WrapperFilterCategories = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	gap: 0.6rem;
`;

export const WrapperFilterDamageArea = styled.div``;
export const GridCheckbox = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
`;
